import { TogglePill } from '@core/ui/TogglePill';

type Project = { id: string; name: string; color: string };

/** Чипы проектов под тулбаром: быстрый фильтр, активный залит цветом проекта; Clear снимает и поиск. */
export function ProjectChips({ projects, selected, onChange, filtered, onClear }: { projects: Project[]; selected: string[]; onChange: (ids: string[]) => void; filtered: boolean; onClear: () => void }) {
  const toggle = (id: string) => onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  return (
    <div className="flex items-center gap-1.5 flex-wrap px-4 py-2 border-b border-gray-200 bg-gray-50" data-project-chips>
      {projects.map((p) => <TogglePill key={p.id} on={selected.includes(p.id)} label={p.name} color={p.color} data={{ 'data-project-chip': p.id }} onClick={() => toggle(p.id)} />)}
      {filtered && <button type="button" className="min-h-0 text-sm text-accent hover:underline ml-1" onClick={onClear}>Clear ×</button>}
    </div>
  );
}
